/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export class CategoriesClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getAvailableCategories: (
			language?: string | undefined,
			includeSubcategories?: boolean | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/categories?';
            if (language === null) {
                throw new Error('The parameter "language" cannot be null.');
            } else if (language !== undefined) {
                clientRequestUrl += 'language=' + encodeURIComponent('' + language) + '&';
            }
            if (includeSubcategories === null) {
                throw new Error('The parameter "includeSubcategories" cannot be null.');
            } else if (includeSubcategories !== undefined) {
                clientRequestUrl += 'includeSubcategories=' + encodeURIComponent('' + includeSubcategories) + '&';
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Get all available Categories for current user
     * @param language (optional) label language
     * @param includeSubcategories (optional) toggle to include subcategories
     * @return List of categories
     */
    getAvailableCategories(language?: string | undefined, includeSubcategories?: boolean | undefined): Promise<GetCategoriesResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getAvailableCategories(
            language,
            includeSubcategories,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetCategoriesResponse>(_response, false, []);
        });
    }
}

export class SearchsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        search: (
			searchTerm?: string | undefined,
			language?: string | undefined,
			page?: number | undefined,
			pageSizeBySearchType?: number | undefined,
			filters_sgm_categoryKeys?: string | undefined,
			filters_sgm_subcategoryKeys?: string | undefined,
			itemTypes?: SearchResultType[] | undefined,
        ): string => {
            let clientRequestUrl = '/api/v1/searchs?';
            if (searchTerm === null) {
                throw new Error('The parameter "searchTerm" cannot be null.');
            } else if (searchTerm !== undefined) {
                clientRequestUrl += 'searchTerm=' + encodeURIComponent('' + searchTerm) + '&';
            }
            if (language === null) {
                throw new Error('The parameter "language" cannot be null.');
            } else if (language !== undefined) {
                clientRequestUrl += 'language=' + encodeURIComponent('' + language) + '&';
            }
            if (page === null) {
                throw new Error('The parameter "page" cannot be null.');
            } else if (page !== undefined) {
                clientRequestUrl += 'page=' + encodeURIComponent('' + page) + '&';
            }
            if (pageSizeBySearchType === null) {
                throw new Error('The parameter "pageSizeBySearchType" cannot be null.');
            } else if (pageSizeBySearchType !== undefined) {
                clientRequestUrl += 'pageSizeBySearchType=' + encodeURIComponent('' + pageSizeBySearchType) + '&';
            }
            if (filters_sgm_categoryKeys === null) {
                throw new Error('The parameter "filters_sgm_categoryKeys" cannot be null.');
            } else if (filters_sgm_categoryKeys !== undefined) {
                clientRequestUrl += 'filters.sgm.categoryKeys=' + encodeURIComponent('' + filters_sgm_categoryKeys) + '&';
            }
            if (filters_sgm_subcategoryKeys === null) {
                throw new Error('The parameter "filters_sgm_subcategoryKeys" cannot be null.');
            } else if (filters_sgm_subcategoryKeys !== undefined) {
                clientRequestUrl += 'filters.sgm.subcategoryKeys=' + encodeURIComponent('' + filters_sgm_subcategoryKeys) + '&';
            }
            if (itemTypes === null) {
                throw new Error('The parameter "itemTypes" cannot be null.');
            } else if (itemTypes !== undefined) {
                itemTypes && itemTypes.forEach(item => { clientRequestUrl += 'itemTypes=' + encodeURIComponent('' + item) + '&'; });
            }
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        searchAllSgm: (
        ): string => {
            let clientRequestUrl = '/api/v1/searchs/do-search-all-sgm';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    }

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Search multi source on sgm services, sg other services, peoples, companies according to criteria
     * @param searchTerm (optional) Term used to search for services.
     * @param language (optional) Lang of Content. Default: en
     * @param page (optional) Number of the current page (default: 1)
     * @param pageSizeBySearchType (optional) Number of elements on page (default: 20, maximum: 500)
     * @param filters_sgm_categoryKeys (optional) Filter by category key separated by comma
     * @param filters_sgm_subcategoryKeys (optional) Filter by subcategory key separated by comma
     * @param itemTypes (optional) Return only specific item types. Return all if not specified
     * @return Search multi source result
     */
    search(searchTerm?: string | undefined, language?: string | undefined, page?: number | undefined, pageSizeBySearchType?: number | undefined, filters_sgm_categoryKeys?: string | undefined, filters_sgm_subcategoryKeys?: string | undefined, itemTypes?: SearchResultType[] | undefined): Promise<GetSearchResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.search(
            searchTerm,
            language,
            page,
            pageSizeBySearchType,
            filters_sgm_categoryKeys,
            filters_sgm_subcategoryKeys,
            itemTypes,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<GetSearchResponse>(_response, false, []);
        });
    }

    /**
     * Search sgm services according to criteria. WITHOUT USER CONTEXT
     * @param body (optional) 
     * @return Search multi source result
     */
    searchAllSgm(body?: SearchAllSgmRequest | undefined): Promise<SgmServiceLitePaginatedResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.searchAllSgm(
        );

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        } as RequestInit;

        return this.http.fetch(clientRequestUrl, options).then((_response: Response) => {
            return Utilities.processResponse<SgmServiceLitePaginatedResponse>(_response, false, []);
        });
    }
}

export interface Category {
    key?: string | undefined;
    label?: string | undefined;
    subcategories?: Subcategory[] | undefined;
}

export interface CompanySearchResultItemDto {
    referenceId?: string | undefined;
    title?: string | undefined;
    url?: string | undefined;
    initials?: string | undefined;
    subtitle?: string | undefined;
    sourceInfos?: SearchResultCompleteItemSourceInfoDto[] | undefined;
    readonly type: SearchResultType;
}

export interface CompanySearchResultItemDtoSearchResultItemsDto {
    items?: CompanySearchResultItemDto[] | undefined;
    searchMetaPageData?: SearchMetaPageDataDto | undefined;
}

export interface ErrorDto {
    code?: string | undefined;
    message?: string | undefined;
    target?: string | undefined;
    details?: ErrorDto[] | undefined;
}

export interface GetCategoriesResponse {
    categories?: Category[] | undefined;
}

export interface GetSearchResponse {
    /** SG Markets service, sub page, related SGM plateform from LinkReferential, board on SG Dashboard */
    sgm?: SgmSearchResultItemDtoSearchResultItemsDto | undefined;
    /** Sg Other service, example from LinkReferential that not related to SGM plateform */
    sg?: SgSearchResultItemDtoSearchResultItemsDto | undefined;
    person?: PersonSearchResultItemDtoSearchResultItemsDto | undefined;
    company?: CompanySearchResultItemDtoSearchResultItemsDto | undefined;
    meta?: SearchMetaPageDataDto | undefined;
}

export interface PersonSearchResultItemDto {
    referenceId?: string | undefined;
    title?: string | undefined;
    url?: string | undefined;
    initials?: string | undefined;
    subtitle?: string | undefined;
    sourceInfos?: SearchResultCompleteItemSourceInfoDto[] | undefined;
    readonly type: SearchResultType;
    fullName?: string | undefined;
}

export interface PersonSearchResultItemDtoSearchResultItemsDto {
    items?: PersonSearchResultItemDto[] | undefined;
    searchMetaPageData?: SearchMetaPageDataDto | undefined;
}

export enum RelationType {
    Board = "Board",
    Page = "Page",
}

export interface SearchAllSgmRequest {
    page: number;
    pageSize: number;
    searchTerm?: string | undefined;
    serviceKeys?: string[] | undefined;
    includeArchived: boolean;
}

export interface SearchMetaPageDataDto {
    page: number;
    pageSizeBySearchType: number;
    /** computed field */
    isFirstPage: boolean;
    /** computed field */
    isLastPage: boolean;
    /** computed field */
    totalCount: number;
    /** computed field */
    totalPage: number;
}

export interface SearchResultCompleteItemSourceInfoDto {
    source: SearchResultItemSource;
    initials?: string | undefined;
    url?: string | undefined;
}

export enum SearchResultItemSource {
    SgmServiceConfig = "SgmServiceConfig",
    SgOtherConfig = "SgOtherConfig",
    SgDashboard = "SgDashboard",
    Org = "Org",
    IC = "iC",
    Research___Insight = "Research & Insight",
    Client_snapshot_360 = "Client snapshot 360",
}

export interface SearchResultSgItemSourceInfoDto {
    source: SearchResultItemSource;
}

export interface SearchResultSgmItemRelatedToDto {
    relationType: RelationType;
    referenceId?: string | undefined;
    url?: string | undefined;
}

export interface SearchResultSgmItemSourceInfoDto {
    source: SearchResultItemSource;
    relatedTo?: SearchResultSgmItemRelatedToDto | undefined;
}

export enum SearchResultType {
    SgmItem = "SgmItem",
    SgItem = "SgItem",
    People = "People",
    Company = "Company",
}

export interface SgSearchResultItemDto {
    referenceId?: string | undefined;
    title?: string | undefined;
    url?: string | undefined;
    initials?: string | undefined;
    readonly type: SearchResultType;
    category?: string | undefined;
    sourceInfos?: SearchResultSgItemSourceInfoDto[] | undefined;
    description?: string | undefined;
}

export interface SgSearchResultItemDtoSearchResultItemsDto {
    items?: SgSearchResultItemDto[] | undefined;
    searchMetaPageData?: SearchMetaPageDataDto | undefined;
}

export interface SgmSearchResultItemDto {
    referenceId?: string | undefined;
    title?: string | undefined;
    url?: string | undefined;
    initials?: string | undefined;
    readonly type: SearchResultType;
    isInternal?: boolean | undefined;
    category?: string | undefined;
    sourceInfos?: SearchResultSgmItemSourceInfoDto[] | undefined;
    description?: string | undefined;
    hasAccess?: boolean | undefined;
}

export interface SgmSearchResultItemDtoSearchResultItemsDto {
    items?: SgmSearchResultItemDto[] | undefined;
    searchMetaPageData?: SearchMetaPageDataDto | undefined;
}

export interface SgmServiceLite {
    serviceKey?: string | undefined;
    name?: string | undefined;
}

export interface SgmServiceLitePaginatedResponse {
    readonly page: number;
    readonly pageSize: number;
    readonly isFirstPage: boolean;
    readonly isLastPage: boolean;
    readonly totalCount: number;
    readonly totalPage: number;
    items?: SgmServiceLite[] | undefined;
}

export interface Subcategory {
    key?: string | undefined;
    label?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

export class Utilities
{
    public static async processResponse<T>(
        response: Response,
        isFile: boolean,
        dateFields: string[],
    ): Promise<T> {
        const status = response.status;
        const _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if (status >= 200 && status < 300) {
            if (isFile) {
                const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
                const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
                return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers } as unknown as T; });
            }
            if (response && response.text) {
                return response.text().then((_responseText) => {
                    try {
                        const result: any = _responseText === '' ? null : JSON.parse(_responseText, (key, value) => {
                            if (value
                                && dateFields?.includes(key)
                                && (typeof value === 'string' || (Array.isArray(value) && value.every(i => typeof i === 'string'))) 
                                ) {
                               if (Array.isArray(value)) {
                                    return value.map(v => Utilities.ConvertToDate(v));
                                }
                                else {
                                    return Utilities.ConvertToDate(value);
                                }
                            }
                            return value;
                        }) as T;
                        return result;
                    } catch (error) {
                        return Promise.reject(new SwaggerException(error instanceof Error ? error.message : 'JSON.parse error', status, _responseText, _headers, null));
                    }
                });
            }
            else {
                return Promise.resolve<T>(<any>null);
            }
        }

        const errorMessage = status < 500 ? 'A server error occurred.' : 'An unexpected server error occurred.';

        if (response instanceof Error) {
        	return Promise.reject(new SwaggerException(response.message, status, response.message, _headers, null));
        }

        if (response && response.text) {
        	const responseText = await response.text();
        	return Promise.reject(new SwaggerException(errorMessage, status, responseText, _headers, null));
        }

        return Promise.resolve<T>(<any>null);
    }

    public static ConvertToDate (value: any) {
        const date = new Date(value);
        return isNaN(date.getTime()) ? value : date;
    }
}